var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundCoursePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 768,
    viewBox: "0 0 1024 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4487_19996)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    fill: "#1B1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.937 242.996L927.937 231.052L895.313 231.052L895.313 240.631L895.313 298.99L927.937 298.99L927.937 242.996Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.313 369.697L895.313 411.952L927.937 411.952L927.937 372.063L927.937 344.014L895.313 344.014L895.313 369.697Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.08 305.19L934.138 305.19L934.138 337.827L1002.08 337.827L1002.08 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.114 305.19L821.175 305.19L821.175 337.827L889.114 337.827L889.114 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.937 31.8685L927.937 19.9237L895.313 19.9237L895.313 29.5029L895.313 87.8622L927.937 87.8622L927.937 31.8685Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.313 158.569L895.313 200.824L927.937 200.824L927.937 160.935L927.937 132.886L895.313 132.886L895.313 158.569Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.08 94.0621L934.138 94.0621L934.138 126.699L1002.08 126.699L1002.08 94.0621Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.114 94.0621L821.175 94.0621L821.175 126.699L889.114 126.699L889.114 94.0621Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.937 457.097L927.937 445.152L895.313 445.152L895.313 454.731L895.313 513.09L927.937 513.09L927.937 457.097Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.313 583.797L895.313 626.053L927.937 626.053L927.937 586.163L927.937 558.114L895.313 558.114L895.313 583.797Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.08 519.29L934.138 519.29L934.138 551.927L1002.08 551.927L1002.08 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.114 519.29L821.175 519.29L821.175 551.927L889.114 551.927L889.114 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.232 242.996L721.232 231.052L688.608 231.052L688.608 240.631L688.608 298.99L721.232 298.99L721.232 242.996Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.608 369.697L688.608 411.952L721.232 411.952L721.232 372.063L721.232 344.014L688.608 344.014L688.608 369.697Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.371 305.19L727.432 305.19L727.432 337.827L795.371 337.827L795.371 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.408 305.19L614.47 305.19L614.47 337.827L682.408 337.827L682.408 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.231 31.8685L721.231 19.9237L688.607 19.9237L688.607 29.5029L688.607 87.8622L721.231 87.8622L721.231 31.8685Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.607 158.569L688.607 200.824L721.231 200.824L721.231 160.935L721.231 132.886L688.607 132.886L688.607 158.569Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.37 94.0621L727.432 94.0621L727.432 126.699L795.37 126.699L795.37 94.0621Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.408 94.0621L614.469 94.0621L614.469 126.699L682.408 126.699L682.408 94.0621Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.232 457.097L721.232 445.152L688.608 445.152L688.608 454.731L688.608 513.09L721.232 513.09L721.232 457.097Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.608 583.797L688.608 626.053L721.232 626.053L721.232 586.163L721.232 558.114L688.608 558.114L688.608 583.797Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.371 519.29L727.432 519.29L727.432 551.927L795.371 551.927L795.371 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.408 519.29L614.47 519.29L614.47 551.927L682.408 551.927L682.408 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.686 242.997L512.686 231.052L480.062 231.052L480.062 240.631L480.062 298.99L512.686 298.99L512.686 242.997Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.062 369.697L480.062 411.953L512.686 411.953L512.686 372.063L512.686 344.014L480.062 344.014L480.062 369.697Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.825 305.19L518.886 305.19L518.886 337.827L586.825 337.827L586.825 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.862 305.19L405.924 305.19L405.924 337.827L473.862 337.827L473.862 305.19Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.686 31.8688L512.686 19.924L480.062 19.924L480.062 29.5032L480.062 87.8625L512.686 87.8625L512.686 31.8688Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.062 158.569L480.062 200.825L512.686 200.825L512.686 160.935L512.686 132.886L480.062 132.886L480.062 158.569Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.825 94.0623L518.886 94.0623L518.886 126.699L586.825 126.699L586.825 94.0623Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.862 94.0623L405.924 94.0623L405.924 126.699L473.862 126.699L473.862 94.0623Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.686 457.097L512.686 445.152L480.062 445.152L480.062 454.731L480.062 513.09L512.686 513.09L512.686 457.097Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.062 583.797L480.062 626.053L512.686 626.053L512.686 586.163L512.686 558.114L480.062 558.114L480.062 583.797Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.825 519.29L518.886 519.29L518.886 551.927L586.825 551.927L586.825 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.862 519.29L405.924 519.29L405.924 551.927L473.862 551.927L473.862 519.29Z",
    fill: "white",
    fillOpacity: 0.03
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4487_19996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCoursePattern);
export default __webpack_public_path__ + "static/media/BackgroundCoursePattern.e0c9185cbfec66e1f26bc1e42d79d716.svg";
export { ForwardRef as ReactComponent };